/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({ tip = '', onHover, children }) => (
  <div
    className="tooltip"
    onMouseEnter={onHover}
    onClick={onHover}
  >
    {children}
    <span className="tooltip-caret" />
    <span className="tooltip-text">
      {tip}
    </span>
  </div>
);

Tooltip.propTypes = {
  children: PropTypes.node,
  onHover: PropTypes.func,
  tip: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
};

export default Tooltip;
